import aponeo from './aponeo';
import { checkApplePayAvailability } from './applepay';

export const ShowHide_bx_tel = () => {
  let ShippingMethodActive = $('input[name=shipping]:checked').val();
  if (
    ShippingMethodActive === '10|1' ||
    ShippingMethodActive === '10|2' ||
    ShippingMethodActive === '11|1' ||
    ShippingMethodActive === '11|2' ||
    ShippingMethodActive === '46|3'
  ) {
    $('#bx-tel-block').show(200);
  } else {
    $('#bx-tel-block').hide(200);
  }
};

export default () => {
  /*
   * when closing address forms, scroll to matching header
   */
  $(document).ready(($) => {
    //-----------------------------------
    // ### Landingpage Rattz-Woche 2019 ###
    //------------------------------------
    if ($('[data-teaser-name="Rabattz Woche 2019 | Header"]').length) {
      $('.apn-page-wrapper').css('background-color', '#000');
      $('footer').css('background-color', '#fff');
      $('.apn-breadcrumb-nav').hide();
      $('.apn-breadcrumb').hide();
    }

    const el = $('.apn-customer-address-list');
    if (el.length) {
      el.on('hide.bs.collapse', (event) => {
        const scrollTarget = $(event.target).prev();
        if (!scrollTarget.isInViewport()) {
          const offset = scrollTarget.offset().top - 15;
          aponeo.scrollTop(offset);
        }
      });
    }

    $('input[name=shipping_calender]').click((event) => {
      // if($('#radio_button').is(':checked')) { alert("it's checked"); }
      let shippingId = $(event.target).attr('data-shipping-id');
      shippingId = shippingId.replace('|', '\\\|');

      $("input[name='shipping']").prop('checked', false); // alle unchecken
      $('#shipping_' + shippingId).prop('checked', true); // die korrekt checken
      ShowHide_bx_tel();
    });

    $('#bx-tel-calender').change(() => {
      $('#bx-tel').val($('#bx-tel-calender').val());
      ShowHide_bx_tel();
    });

    $("input[name='shipping']").change(() => {
      ShowHide_bx_tel();
    });

    const $checkoutShippingMethodForm = $("form[name='checkout_shipping_method']");
    $checkoutShippingMethodForm.submit(() => {
      let ShippingMethodActive = $('input[name=shipping]:checked').val();
      if (
        ShippingMethodActive === '10|1' ||
        ShippingMethodActive === '10|2' ||
        ShippingMethodActive === '11|1' ||
        ShippingMethodActive === '11|2' ||
        ShippingMethodActive === '46|3'
      ) {
        const $bxTel = $('#bx-tel');
        if ($bxTel.val().length < 6) {
          $bxTel.hide(200);
          $bxTel.show(200);
          $bxTel.css({ border: '1px solid #fe2550' });
          return false;
        }
      }
    });

    if ($checkoutShippingMethodForm.length > 0) {
      ShowHide_bx_tel();
    }

    // checkout shipping calendar
    const $modalCheckoutCalendar = $('.modal-checkout-calendar');
    if ($modalCheckoutCalendar.length) {
      const deliveryTypeElement = $('#delivery-type');
      $modalCheckoutCalendar.find('input[type="radio"]').on('change', (event) => {
        deliveryTypeElement.text($(event.target).data('name'));
        $modalCheckoutCalendar.find('.collapse').collapse('hide');
        if ($(event.target).data('target')) {
          $($(event.target).data('target')).collapse('show');
        }
      });
    }

    // hide any open payment panel when another radio is selected
    $(document).on('change', '#payment-method input[type="radio"]', function () {
      var $target = $($(this).data('target'));
      $('#payment-method .collapse.show').not($target).collapse('hide');
    });

    // Mobile Pay: detect Apple Pay support and set data attributes for CSS visibility
    const mobilePay = document.querySelector('[data-mobile-pay]');
    if (mobilePay) {
      (async () => {
        const hasApplePaySupport = await checkApplePayAvailability();
        mobilePay.dataset.applePay = hasApplePaySupport ? 'true' : 'false';
      })();
    }
  });

  const showInvoiceButton = (id) => {
    $.ajax({
      type: 'GET',
      url: '/kundenbereich/hasinvoice/' + id,
    })
      .fail(() => {
        console.log(id + 'error');
      })
      .done((result) => {
        if (result === '1') {
          $('#_btn-invoice_download_' + id).show(700);
        }
      });
  };
};
